var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.34763 2.6264C8.07329 2.6264 6.82758 3.00429 5.76801 3.71227C4.70844 4.42025 3.8826 5.42653 3.39494 6.60386C2.90727 7.78119 2.77968 9.07669 3.02829 10.3265C3.2769 11.5764 3.89055 12.7244 4.79164 13.6255C5.69273 14.5266 6.84078 15.1403 8.09063 15.3889C9.34048 15.6375 10.636 15.5099 11.8133 15.0222C12.9906 14.5346 13.9969 13.7087 14.7049 12.6492C15.4129 11.5896 15.7908 10.3439 15.7908 9.06955C15.7907 7.36075 15.1118 5.72198 13.9035 4.51368C12.6952 3.30538 11.0564 2.62651 9.34763 2.6264V2.6264Z",
    stroke: "#585858",
    strokeWidth: 1.00189,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1541 13.8766L18.6557 18.3782",
    stroke: "#585858",
    strokeWidth: 1.00189,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f4b90199b28d4e6e402ff62428c9ee8c.svg";
export { ForwardRef as ReactComponent };